var React = require('react');

function Fi (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"11","fill":"white","key":0}),React.createElement("mask",{"id":"mask0","maskUnits":"userSpaceOnUse","x":"2","y":"2","width":"20","height":"20","key":1},React.createElement("path",{"d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","fill":"#F0F0F0"})),React.createElement("g",{"mask":"url(#mask0)","key":2},[React.createElement("path",{"d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","fill":"#F0F0F0","key":0}),React.createElement("path",{"d":"M11 1.375L8 1.125V10.5H-1L-0.75 13.5H8V23.25H11V13.5H24.625V10.5H11V1.375Z","fill":"#0052B4","key":1})])]);
}

Fi.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Fi;

Fi.default = Fi;
